export class Notification {
    public message: string;
    public level: string;

    constructor(message: string, level: string){
        this.message = message;
        this.level = level;
    }

}




// WEBPACK FOOTER //
// ./src/app/notifier/notification.model.ts